import script from "./ToggleDisplay.vue?vue&type=script&lang=js"
export * from "./ToggleDisplay.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__